import { Drawer, Spin } from 'antd';
import { BaseButton } from 'components/button/button-base';
import { FormPatientAdd } from 'features/clinician/patient/patient-list/_components/form-patient-add';

interface AddPatientDrawerProps {
  /**
   * If the drawer is open
   */
  visible: boolean;
  /**
   * Callback when the drawer is closed
   */
  onClose: () => void;
  /**
   * Callback when a patient is added
   */
  onSuccess: () => void;
}

/**
 * Renders the Add Patient drawer.
 *
 * @param props - Props defined in {@link AddPatientDrawerProps}.
 * @returns JSX element.
 */
export function AddPatientDrawer(props: AddPatientDrawerProps) {
  return (
    <Drawer
      title=""
      placement="right"
      onClose={props.onClose}
      open={props.visible}
      destroyOnClose
    >
      <FormPatientAdd
        passportId={undefined}
        onSuccess={(_, form) => {
          props.onSuccess();
          props.onClose();
          form.resetFields();
        }}
        title={{
          content: 'Add a test-taker using their ImPACT Passport ID',
          level: 5
        }}
        instructionText={{
          content:
            'Enter the Passport ID below to add them to your organisation.'
        }}
        renderCancel={() => (
          <BaseButton onClick={props.onClose} type="text">
            Cancel
          </BaseButton>
        )}
        renderFooter={status => {
          if (status.isPending) {
            return <Spin tip="Adding test-taker..." />;
          }
          return null;
        }}
      />
    </Drawer>
  );
}
